import { render, staticRenderFns } from "./ReceiptSettings.vue?vue&type=template&id=0424b1dc&"
import script from "./ReceiptSettings.vue?vue&type=script&lang=ts&"
export * from "./ReceiptSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports